import Home from '../views/Home.vue'
export default {
  path: '/proList',
  name: '装备清单',
  component: Home,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: true,
  children: [
    {
      path: '/proList',
      component: () =>
                import('../views/proList/index'),
      name: '装备清单',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/proList/details',
      component: () =>
                import('../views/proList/details/index.vue'),
      name: '清单正文', // 空间介绍-正文
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
